const PHASES = {
  LOBBY: 'LOBBY',
  DEALING: 'DEALING',
  REVEALING: 'REVEALING',
  PLAYING: 'PLAYING',
  ROUND_END_PHASE: 'ROUND_END_PHASE',
  ROUND_END: 'ROUND_END',
  GAME_OVER: 'GAME_OVER',
};

const TURN_PHASES = {
  WAITING_DRAW: 'WAITING_DRAW',
  WAITING_DECISION: 'WAITING_DECISION',
};

const MIN_PLAYERS = 2;
const MAX_PLAYERS = 6;
const TOTAL_ROUNDS = 9;
const CARDS_PER_HAND = 6;
const INITIAL_REVEAL_COUNT = 2;
const TURN_TIMEOUT_MS = 60000;
const DISCONNECT_TIMEOUT_MS = 30000;

function canStartGame(players) {
  const playerList = Object.values(players || {});
  if (playerList.length < MIN_PLAYERS || playerList.length > MAX_PLAYERS) {
    return false;
  }
  return playerList.every(p => p.ready);
}

function canDraw(currentTurn, playerId) {
  return (
    currentTurn.playerId === playerId &&
    currentTurn.phase === TURN_PHASES.WAITING_DRAW
  );
}

function canSwapOrDiscard(currentTurn, playerId) {
  return (
    currentTurn.playerId === playerId &&
    currentTurn.phase === TURN_PHASES.WAITING_DECISION
  );
}

function getNextPlayerId(playerOrder, currentPlayerId) {
  const idx = playerOrder.indexOf(currentPlayerId);
  return playerOrder[(idx + 1) % playerOrder.length];
}

function getColumnPairs() {
  return [[0, 3], [1, 4], [2, 5]];
}

export {
  PHASES,
  TURN_PHASES,
  MIN_PLAYERS,
  MAX_PLAYERS,
  TOTAL_ROUNDS,
  CARDS_PER_HAND,
  INITIAL_REVEAL_COUNT,
  TURN_TIMEOUT_MS,
  DISCONNECT_TIMEOUT_MS,
  canStartGame,
  canDraw,
  canSwapOrDiscard,
  getNextPlayerId,
  getColumnPairs,
};
